<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button class="btn" type="primary" v-if="show.zj" @click="handleCreate" icon="el-icon-plus">增加</el-button>
        <!-- <el-button class="btn" type="primary" @click="handleCreate1" icon="el-icon-edit">修改</el-button> -->
        <!-- <el-button class="btn" type="primary" @click="handleCreate2" icon="el-icon-delete">删除</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float: right !important" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"
              @keyup.enter.native="getDeviceinfoClick"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getDeviceinfoClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="userData" tooltip-effect="dark"
          style="width: 100%; text-align: center" stripe>
          <el-table-column label="序号" type="index" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userId" sortable label="用户账号" width="120PX">
          </el-table-column>
          <el-table-column prop="userName" sortable label="用户姓名" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="roleName" sortable label="用户角色" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="tel" sortable label="联系电话   " show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="companyName" sortable label="所属单位" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="isDelete" sortable label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.locked == 1" style="color: red">已锁定</span>
              <span v-else-if="scope.row.isDelete == 1" style="color: cornflowerblue">正常</span>
              <span v-else-if="scope.row.isDelete == 0" style="color: blueviolet">停用</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="fjqx" label="附加权限" >
          </el-table-column> -->
          <el-table-column sortable prop="createTime" :formatter="formateTime" label="录入日期" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="show.czmm && scope.row.isDelete == 1" @click="selectClick(scope.row)" type="text"
                size="small">重置密码
              </el-button>
              <el-button v-if="scope.row.locked == 1 && scope.row.isDelete == 1" @click="handleUnlock(scope.row)"
                type="text" size="small" style="color: #67C23A;">解锁
              </el-button>
              <el-button v-if="show.sc && scope.row.isDelete == 1" @click="deleteUser(scope.row)" type="text"
                size="small">停用
              </el-button>
              <el-button v-if="show.xg && scope.row.isDelete == 1" @click="handleCreate1(scope.row)" type="text"
                size="small">修改
              </el-button>
              <el-button v-if="show.sc && scope.row.isDelete == 0" @click="start(scope.row)" type="text" size="small">启用
              </el-button>
              <el-button v-if="show.scPlus && scope.row.isDelete == 0" @click="userinfoDel(scope.row)" type="danger"
                size="small">删除
              </el-button>
              <el-button v-if="show.scPlus && scope.row.isDelete == 1" @click="impersonateUser(scope.row)" type="text"
                size="small" style="color: #E6A23C;">模拟登录
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="userData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-------------------------------------------------------------------------添加用户------------------------------------------------------------------------------------------>
    <el-dialog :visible.sync="dialogVisible" title="账户信息管理" :close-on-click-modal="false" :close-on-press-escape="false"
      style="width: 60% !important; margin-left: 400px">
      <el-form :model="questionForm" ref="questionForm" :rules="rules" label-position="left" label-width="100px"
        style="width: 80%; margin-left: 10%">
        <el-form-item label="用户账号" prop="userId">
          <el-input placeholder="请输入用户名" v-model.trim="questionForm.userId" />
        </el-form-item>
        <el-form-item label="用户姓名" prop="userName">
          <el-input placeholder="请输入用户姓名" v-model.trim="questionForm.userName" />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input placeholder="请输入联系电话" v-model.trim="questionForm.tel" />
        </el-form-item>
        <el-form-item label="所属单位" prop="companyCode">
          <!-- <el-cascader v-model="questionForm.companyCode" style="width:100%" :options="options" :props="props"
            :show-all-levels="true" filterable></el-cascader> -->
          <el-cascader v-model="questionForm.companyCode" :options="options" :show-all-levels="false" :props="props"
            clearable></el-cascader>
        </el-form-item>
        <el-form-item label="用户角色" prop="userRole"><el-select style="width: 100%" v-model="questionForm.userRole"
            placeholder="请选择角色">
            <el-option v-for="item in options2" :key="item.roleId" :label="item.roleName" :value="item.roleId">
            </el-option> </el-select></el-form-item>
        <el-form-item label=" 附加权限">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="1">检测维保人员</el-checkbox>
            <el-checkbox label="6">办公维保人员</el-checkbox>
            <el-checkbox label="2">设备需审核</el-checkbox>
            <el-checkbox label="3">全部检测设备</el-checkbox>
            <el-checkbox label="4">全部办公设备</el-checkbox>
            <el-checkbox label="7">设备超市管理员</el-checkbox>
          </el-checkbox-group></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="insertUser" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>

    <!-------------------------------------------------------------------------修改用户------------------------------------------------------------------------------------------>
    <el-dialog :visible.sync="dialogVisible1" title="账户信息管理" :close-on-click-modal="false"
      :close-on-press-escape="false" style="width: 60% !important; margin-left: 400px">
      <el-form :model="userForm" ref="userForm" :rules="rules" label-position="left" label-width="100px"
        style="width: 80%; margin-left: 10%">
        <el-form-item label="用户姓名" prop="userName">
          <el-input placeholder="请输入用户姓名" v-model.trim="userForm.userName" />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input placeholder="请输入联系电话" v-model.trim="userForm.tel" />
        </el-form-item>
        <el-form-item label="所属单位">
          <!-- <el-cascader v-model="userForm.companyCode" style="width:100%" :options="options" :props="props"
            :show-all-levels="true" filterable></el-cascader> -->
          <el-cascader v-model="userForm.companyCode" :options="options" :show-all-levels="false" :props="props"
            clearable></el-cascader>
        </el-form-item>

        <el-form-item label="用户角色"><el-select style="width: 100%" v-model="userForm.userRole" placeholder="请选择角色">
            <el-option v-for="item in options2" :key="item.roleId" :label="item.roleName" :value="item.roleId">
            </el-option> </el-select></el-form-item>
        <el-form-item label=" 附加权限">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="1">检测维保人员</el-checkbox>
            <el-checkbox label="6">办公维保人员</el-checkbox>
            <el-checkbox label="2">设备需审核</el-checkbox>
            <el-checkbox label="3">全部检测设备</el-checkbox>
            <el-checkbox label="4">全部办公设备</el-checkbox>
            <el-checkbox label="7">设备超市管理员</el-checkbox>
          </el-checkbox-group></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="updateByIdUser" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="dialogPwdShow" width="300" title="提示" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="padding: 50px 0;">重置成功，新密码：<span>{{ newPwd }}</span></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findAllUserList,
  findByIdUser,
  treeCompany,
  selectAllDepartment,
  addUser,
  delUser,
  updateUser,
  resettingPassword,
  selectAllRole,
  insetUser,
  userDel,
  getCompanyPCodeList,
  unlockUser,
  impersonate,
} from "../../api/api";
import { resetLoginRedirect } from "../../api/api";
export default {
  name: "AccountNumber",
  data() {
    let checkPwd = (rule, value, callback) => {
      if (value.trim().length == 0) {
        callback(new Error("请输入确认密码"));
      } else if (value != this.form.newPassword) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    var accountVlidate = (rule, val, callback) => {
      if (!val) {
        callback(new Error("请输入用户账号"));
      } else {
        const reg = /^([a-zA-z]+|[0-9]+|[0-9a-zA-z])*$/;
        if (reg.test(val)) {
          return callback();
        } else {
          callback(new Error("仅支持输入纯数字、字母"));
        }
      }
    };
    var isMobileNumber = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入电话号码");
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        const isPhone = reg.test(value);
        value = Number(value); //转换为数字
        if (typeof value === "number" && !isNaN(value)) {
          //判断是否为数字
          value = value.toString(); //转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            //判断是否为11位手机号
            callback(new Error("手机号码格式如:138xxxx8754"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入电话号码"));
        }
      }
    };
    return {
      deviceInfo: {
        content: "",
      },
      show: {
        zj: false,
        xg: false,
        sc: false,
        czmm: false,
        scPlus: false,
      },
      questionForm: {},
      userForm: {},
      form: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      checkList: [],
      multipleSelection: [],
      userData: [],
      dialogVisible: false,
      dialogVisible1: false,
      // dialogVisible2: false,
      options: [],
      options1: [],
      options2: [],
      dialogPwdShow: false,
      newPwd: "",
      props: {
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        checkStrictly: true,
        emitPath: false,
      },
      rules: {
        userId: [
          { required: true, message: "请输入用户账号", trigger: "blur" },
          {
            min: 3,
            max: 128,
            message: "长度在 3 到 128 个字符",
            trigger: "blur",
          },
          { validator: accountVlidate, trigger: "blur" },
        ],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "长度在 2 到 128 个字符",
            trigger: "blur",
          },
        ],
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
        companyCode: [
          { required: true, message: "请选择部门", trigger: "blur" },
        ],
        userRole: [
          { required: true, message: "请选择用户角色", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getDeviceinfo();
    this.selectCompany();
    this.selectDepartment();
    this.selectRole();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    if (userinfo.userRole == 1) {
      this.show.scPlus = true;
    }
    arr.forEach((i) => {
      if (i == "124") {
        this.show.zj = true;
      }
      if (i == "125") {
        this.show.xg = true;
      }
      if (i == "126") {
        this.show.sc = true;
      }
      if (i == "127") {
        this.show.czmm = true;
      }
    });
  },
  methods: {
    userinfoDel(row) {
      this.$confirm("此操作将永久删除该账号,是否确认", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userDel(row.userId).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.getDeviceinfo();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    start(row) {
      this.$confirm("确认是否启用该账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        insetUser(row.userId).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.getDeviceinfo();
            this.$message({
              message: "启用成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    //查找所有角色
    selectRole() {
      selectAllRole().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options2 = data;
        }
      });
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.createTime);
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, "0");
      let date = nowData.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    //查找所有部门
    selectDepartment() {
      selectAllDepartment().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options1 = data;
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    //添加用户信息
    insertUser() {
      const filteredArr = this.checkList.filter(
        (element) => element !== null && element !== undefined && element !== ""
      );
      const uniqueArr = [...new Set(filteredArr)];
      this.questionForm.fjqx = uniqueArr.toString();
      this.$refs.questionForm.validate((valid) => {
        if (valid) {
          addUser(this.questionForm).then((datas) => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.getDeviceinfo();
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.dialogVisible = false;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改用户信息
    updateByIdUser() {
      const filteredArr = this.checkList.filter(
        (element) => element !== null && element !== undefined && element !== ""
      );
      const uniqueArr = [...new Set(filteredArr)];
      console.log("uniqueArr", uniqueArr);
      this.userForm.fjqx = uniqueArr.toString();
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          updateUser(this.userForm).then((datas) => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.getDeviceinfo();
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.dialogVisible1 = false;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 解锁用户
    handleUnlock(row) {
      this.$confirm("确认解锁该账号？锁定原因：" + (row.lockReason || "无"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        unlockUser({ userId: row.userId }).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.getDeviceinfo();
            this.$message({ message: "解锁成功", type: "success" });
          } else {
            this.$message({ message: message || "解锁失败", type: "error" });
          }
        });
      });
    },
    selectClick(row) {
      this.$confirm("确认是否重置密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        resettingPassword(row.userId).then((datas) => {
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.getDeviceinfo();
            this.dialogPwdShow = true
            this.newPwd = data
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    //查找单位
    selectCompany() {
      treeCompany().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    //修改用户
    handleCreate1(row) {
      this.checkList = [];
      var that = this;
      findByIdUser(row.userId).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          that.userForm = data;
          if (data.fjqx != null) {
            this.checkList = data.fjqx.split(",");
          }
          this.dialogVisible1 = true;
        }
      });
    },
    //删除用户
    deleteUser(row) {
      this.$confirm("此操作停用该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var arr = [];
        arr.push(row.userId);
        delUser(arr).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.$message({
              message: "停用成功",
              type: "success",
            });
            this.getDeviceinfo();
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    handleCreate() {
      this.dialogVisible = true;
      this.questionForm = {};
    },
    getDeviceinfoClick() {
      this.pageIndex = 1;
      this.getDeviceinfo();
    },
    //查找用户信息
    getDeviceinfo() {
      findAllUserList(this.deviceInfo).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) {
            this.data = [];
          } else {
            this.data = data;
          }
          this.userData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.userData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.userData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    // 模拟登录
    impersonateUser(row) {
      this.$confirm(`确认模拟登录用户「${row.userName}(${row.userId})」吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        impersonate(row.userId).then((datas) => {
          let { status, message, data } = datas;
          if (status == 200) {
            // 更新 localStorage 中的用户信息
            localStorage.setItem("user", JSON.stringify(data));
            localStorage.setItem("token", new Date().getTime());
            localStorage.setItem("impersonating", "true");
            resetLoginRedirect();
            this.$message({ message: `已切换至用户 ${data.userName}`, type: "success" });
            // 延迟跳转到设备信息页，避免停留在无权限页面
            setTimeout(() => {
              window.location.href = window.location.pathname + '#/DeviceInfo';
            }, 300);
          } else {
            this.$message({ message: message || "模拟登录失败", type: "error" });
          }
        });
      });
    },
  },
};
</script>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/SystemSettings/AccountNumber.vue